import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { TrendingUpDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	PageNavigatorHost,
	PageNavigatorProvider,
} from '@/shared/components/PageNavigator'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
} from '@/shared/components/ui/breadcrumb'
import { Button } from '@/shared/components/ui/button'
import { Header, Layout } from '@/shared/components/ui/layout'
import { Separator } from '@/shared/components/ui/separator'

function WhatIfHost() {
	const { t } = useTranslation()

	return (
		<PageNavigatorProvider>
			<Layout>
				<Header className='h-11 items-center border-b px-4 py-2'>
					<TrendingUpDownIcon className='size-4' />
					<Separator orientation='vertical' className='mx-2 h-5' />
					<Breadcrumb className='mr-2 text-sm'>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbPage>{t('whatif')}</BreadcrumbPage>
							</BreadcrumbItem>
						</BreadcrumbList>
					</Breadcrumb>
					<Separator orientation='vertical' className='mx-2 h-5' />

					<div className='flex items-center gap-2'>
						<Button
							size='sm'
							variant='outline'
							asChild
							className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
						>
							<Link to='/p/whatif/scenarios'>{t('scenarios')}</Link>
						</Button>
						<Button
							size='sm'
							variant='outline'
							asChild
							className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
						>
							<Link to='/p/whatif/sets'>
								{t('global_sets', { defaultValue: 'Global sets' })}
							</Link>
						</Button>
						<Button
							size='sm'
							variant='outline'
							asChild
							className='data-[status=active]:bg-muted dark:data-[status=active]:bg-muted'
						>
							<Link to='/p/whatif/runs'>{t('scenarios.summary.title')}</Link>
						</Button>
					</div>

					<div className='ml-auto'>
						<PageNavigatorHost />
					</div>
				</Header>
				<Outlet />
			</Layout>
		</PageNavigatorProvider>
	)
}

export const Route = createFileRoute('/_app/p/whatif')({
	component: WhatIfHost,
})
